export const COACH = {
	LEO: 'LEO',
	MIA: 'MIA',
};

export type CoachType = keyof typeof COACH;
